import request from "@/utils/request"

// 地图搜索
export function GetPlaceSearchMap(address, ak) {
  return request({
    url: "/Imp/ImpHydrology/GetPlaceSearchMap",
    method: "get",
    isAnonymous: true,
    params: { address, ak },
  })
}
